import { Col, Input, Row, Select } from 'antd';

import { useDistributorData } from '../../../Hooks/useDistributorData/useDistributorData';

import { IDistributorData } from './IDistributorData';

import './DistributorData.scss';
import FormLayout from '../../FormLayout/FormLayout';
import { DistributorsAPI } from '../../../Api/DistributorsAPI';
import { ContractAPI } from '../../../Api/ContractAPI';
import NameField from '../../Fields/NameField/NameField';
import LastNameField from '../../Fields/LastNameField/LastNameField';
import SecondLastNameField from '../../Fields/SecondLastNameField/SecondLastNameField';

const { Option } = Select;

const DistributorData = ({
	baseURL,
	translations,
	clientId,
	unlockNextStep,
	baseURLExternal,
	isReadOnly = false
}: IDistributorData) => {

	const distributorsAPI = DistributorsAPI(baseURL, clientId);
	const contractAPI = ContractAPI(baseURL, baseURLExternal, clientId);
	const {
		loading,
		errors,
		distributorData,
		contractId,
		defaultValues,
		handleChangeData,
		saveData,
	} = useDistributorData({
		translations,
		distributorsAPI,
		unlockNextStep,
		contractAPI
	});

	return (
		<FormLayout 
			translations={translations}
			loading={loading}
			title={translations.datosDistribuidor}
			subTitle={translations.datosCumplimenta}
			onClick={saveData}
			contractId={contractId}
			nextStep={unlockNextStep}
			enableNextStep={(distributorData.id && distributorData.id > 0) ? true : false}
			forceEnableNextStep={isReadOnly}
			hideSaveButton={isReadOnly}
		>	
			<Row gutter={[16, 16]}>
				<NameField
					name={ distributorData.name }
					size="s"
					translations={ translations}
					errors={ errors }
					handleChangeData={ handleChangeData }
					disabled={isReadOnly || defaultValues.some(defVal => defVal.field === "name")}
				/>
				<LastNameField
					lastName={ distributorData.lastName }
					size="s"
					translations={ translations }
					errors={ errors }
					handleChangeData={ handleChangeData }
					disabled={isReadOnly || defaultValues.some(defVal => defVal.field === "lastName")}
				/>
				<SecondLastNameField
					lastName={ distributorData.secondLastName! }
					size="s"
					translations={ translations }
					errors={ errors }
					handleChangeData={ handleChangeData }
					disabled={isReadOnly || defaultValues.some(defVal => defVal.field === "secondLastName")}
				/>
				<Col xs={24} md={6} lg={6} >
					<label className="required"> {translations.tipo}</label>
					<Select
						className="input-field"
						value={distributorData.type}
						onChange={(value: string) => handleChangeData(0)({ target: { name: 'type', value} })}
						disabled={isReadOnly || defaultValues.some(defVal => defVal.field === "type" && defVal.value)}
					>
						<Option value={"distributor"}>{translations.distribuidor}</Option>
						<Option value={"investor"}>{translations.inversor}</Option>
					</Select>
				</Col>
				<Col xs={24} md={12} lg={12} >
					<label className="required"> {translations.emailFirmante}</label>
					<Input
						type="email"
						name="email"
						value={distributorData.email}
						onChange={ handleChangeData(0) }
						placeholder={translations.emailFirmante}
						disabled={isReadOnly || defaultValues.some(defVal => defVal.field === "email" && defVal.value)}
					/>
					<span className={`error ${errors.email ? 'show' : null}`}>{translations.completeEmailFirmante}</span>
				</Col>
				<Col xs={24} md={4} lg={4} >
					<label className="required"> {translations.phonePrefix}</label>
					<Input
						type="text"
						name="phonePrefix"
						value={distributorData.phonePrefix}
						onChange={ handleChangeData(0) }
						placeholder="+34"
						disabled={isReadOnly || defaultValues.some(defVal => defVal.field === "phonePrefix" && defVal.value)}
					/>
					<span className={`error ${errors.phonePrefix ? 'show' : null}`}>{translations.completeTelefonoFirmante}</span>
				</Col>
				<Col xs={24} md={8} lg={8} >
					<label className="required"> {translations.telefonoContacto}</label>
					<Input
						type="text"
						name="phoneNumber"
						value={distributorData.phoneNumber}
						onChange={ handleChangeData(0) }
						placeholder="000 000 000"
						disabled={isReadOnly || defaultValues.some(defVal => defVal.field === "phoneNumber" && defVal.value)}
					/>
					<span className={`error ${errors.phoneNumber ? 'show' : null}`}>{translations.completeTelefonoFirmante}</span>
				</Col>
			</Row>
			<h3 className="notificacions-msg">{translations.notifications}</h3>
			<Row gutter={[16, 16]}>
				<Col xs={24} md={16} lg={16} >
					<span>{translations.notificationsMessage}</span>
				</Col>
				<Col xs={24} md={8} lg={8} >
					<Input.TextArea
						autoSize
						name="emailToNotify"
						value={distributorData.emailToNotify}
						onChange={ handleChangeData(0) }
						placeholder={translations.emailFirmante}
						disabled={isReadOnly || defaultValues.some(defVal => defVal.field === "emailToNotify" && defVal.value)}
					/>
					<span className="semi-colon-msg">{translations.notificationsMessage2}</span>
				</Col>
				
			</Row>
		</FormLayout>
	);
};

export default DistributorData;
